import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from '../Loading/SplashScreen';
import AuthService from '../../services/authService';
import useSessionTracking from '../../hooks/useSessionTracking';

const { logout, setUserData } = require('../../actions/accountActions');

function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const sessionId = AuthService.getSessionId();

  useEffect(() => {
    const initAuth = async () => {
      AuthService.setAxiosInterceptors({ onLogout: () => dispatch(logout()) });

      AuthService.handleAuthentication();

      if (AuthService.isAuthenticated()) {
        const user = await AuthService.loginInWithToken();
        if (user) {
          await dispatch(setUserData(user));
        } else {
          await dispatch(logout());
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  useSessionTracking(sessionId);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth;
